var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Form', {
    attrs: {
      "url": "/nfe/update",
      "nfe": _vm.nfe
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };